import Axios from 'axios';

import {
  ACTIONS,
  MUTATIONS,
  PayloadParameterRequired as PPR,
} from '@/store/Constants';

const scaffold = (endpoint) => ({
  [ACTIONS.CREATE]: async (context, payload) => {
    if (!payload) {
      throw new Error(PPR.Message);
    }

    const requestObj = {
      config: {
        headers: {
          'Content-Type': 'application/json',
        },
      },
      data: payload,
      method: 'POST',
      url: endpoint,
    };

    try {
      context.commit(MUTATIONS.SET_IS_LOADING, true);
      const { data: { code, message } } = await Axios(requestObj);
      if (![200, 201].includes(code)) {
        throw new Error(message);
      }
      await context.dispatch(ACTIONS.LOAD);
    } catch (err) {
      const errorDescription = (err.response && err.response.data)
        ? err.response.data.message
        : err.message;
      throw new Error(errorDescription);
    } finally {
      context.commit(MUTATIONS.SET_IS_LOADING, false);
    }
  },
  [ACTIONS.DELETE]: async (context, payload) => {
    if (!payload) {
      throw new Error(PPR.Message);
    }

    try {
      context.commit(MUTATIONS.SET_IS_LOADING, true);
      const { data: { code, message } } = await Axios.delete(`${endpoint}/${payload.id}`);
      if (code !== 200) {
        throw new Error(message);
      }
      await context.dispatch(ACTIONS.LOAD);
    } catch (err) {
      const errorDescription = (err.response && err.response.data)
        ? err.response.data.message
        : err.message;
      throw new Error(errorDescription);
    } finally {
      context.commit(MUTATIONS.SET_IS_LOADING, false);
    }
  },
  [ACTIONS.EDIT]: async (context, payload) => {
    if (!payload) {
      throw new Error(PPR.Message);
    }

    const requestObj = {
      config: {
        headers: {
          'Content-Type': 'application/json',
        },
      },
      data: payload,
      method: 'PUT',
      url: `${endpoint}/${payload.id}`,
    };

    try {
      context.commit(MUTATIONS.SET_IS_LOADING, true);
      const { data: { code, message } } = await Axios(requestObj);
      if (![200, 201].includes(code)) {
        throw new Error(message);
      }
      await context.dispatch(ACTIONS.LOAD);
    } catch (err) {
      const errorDescription = (err.response && err.response.data)
        ? err.response.data.message
        : err.message;
      throw new Error(errorDescription);
    } finally {
      context.commit(MUTATIONS.SET_IS_LOADING, false);
    }
  },
  [ACTIONS.LOAD]: async (context) => {
    context.commit(MUTATIONS.SET_IS_LOADING, true);
    context.commit(MUTATIONS.SET_DATA, []);

    try {
      const { data: { code, message, result } } = await Axios.get(endpoint);
      if (code !== 200) {
        throw new Error(message);
      }
      context.commit(MUTATIONS.SET_DATA, result);
    } catch (error) {
      throw new Error(`Could not load data - ${error}`);
    } finally {
      context.commit(MUTATIONS.SET_IS_LOADING, false);
    }
  },
  [ACTIONS.LOAD_PAGINATION]: async (context, payload) => {
    if (!payload) {
      throw new Error(PPR.Message);
    }
    context.commit(MUTATIONS.SET_IS_LOADING, true);
    context.commit(MUTATIONS.SET_DATA, []);

    try {
      const { page, size } = payload;
      const { data } = await Axios.get(`${endpoint}?_page=${page}&_limit=${size}`);

      context.commit(MUTATIONS.SET_DATA, data.result);
      context.commit(MUTATIONS.SET_TOTAL_PAGINATED_DATA, data.totalElements);
    } catch (error) {
      throw new Error(`Could not load data - ${error}`);
    } finally {
      context.commit(MUTATIONS.SET_IS_LOADING, false);
    }
  },
  [ACTIONS.TOGGLE_STATUS]: async (context, payload) => {
    if (!payload) {
      throw new Error(PPR);
    }

    const requestObj = {
      config: {
        headers: {
          'Content-Type': 'application/json',
        },
      },
      data: payload,
      method: 'PUT',
      url: `${endpoint}/${payload.id}/isDisabled/${!payload.isDisabled}`,
    };

    try {
      context.commit(MUTATIONS.SET_IS_LOADING, true);
      const { data: { code, message } } = await Axios(requestObj);
      if (code !== 200) {
        throw new Error(message);
      }
      await context.dispatch(ACTIONS.LOAD);
    } catch (error) {
      const errorDescription = (error.response && error.response.data)
        ? error.response.data.message
        : error.message;
      throw new Error(errorDescription);
    } finally {
      context.commit(MUTATIONS.SET_IS_LOADING, false);
    }
  },
});

export default {
  scaffold,
};
